module.exports = __webpack_public_path__ + "static/media/ftfCalebe.ceb154b0.md";